import { Chip, Grid,  Stack, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';

import CardQuick from '../../components/Card';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import MaterialReactTable from 'material-react-table';
import { useNavigate } from 'react-router-dom';
import { commonService } from '../../services';
import StyledChip from '../../components/StyledChip';




const EsquebrasUsagePage = () => {
  const navigate = useNavigate()
  const [data, setData] = useState([]);



  useEffect(() => {
    commonService.esquebraUsages().then((data) => {
      setData(data)
    }).catch((err) => {

    })
  }, [])

  const columns = useMemo(
    () => [
      {
        accessorKey: 'card_number',
        header: 'Nº Cartão',
        size: 10,
      },
      {
        accessorKey: 'card_name',
        header: 'Beneficiário',
      },
      {
        accessorKey: 'description',
        header: 'Titulo',
      },
      {
        accessorKey: 'location_name',
        header: 'Local de Prestação',

      },
      {
        accessorKey: 'created_at',
        header: 'Data de Ativação',

      },
      {
        accessorKey: 'customer_usage_date',
        header: 'Data de Utilização',

      },
      {
        header: 'Estado',
        accessorKey: 'esquebra_status_name',
        Cell: ({ cell, row }) => (
          <StyledChip label={row.original.esquebra_status_name} defaultColor={row.original.esquebra_status_color} />
        ),
      },
    ],
    [],
  );
  return (
    <React.Fragment>

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography variant='h1' fontWeight={600}>Utilizações de Esquebra</Typography>
        </Grid>
        <Grid item xs={12}>
          <CardQuick

            headerSx={{
              '& .MuiCardHeader-title': {
                fontSize: '16pt',
                fontWeight: 'bolder'
              },
            }}

            wrapperSx={{ pt: 1 }}
            action={
              <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="flex-end"
                spacing={0.5}
              >
              </Stack>
            }

          >
            <MaterialReactTable
              columns={columns}
              data={data}
              initialState={{ showColumnFilters: false, density: 'compact' }}
              enableFullScreenToggle={false}
              localization={MRT_Localization_PT_BR}
              enableFilters={false}
              enableDensityToggle={false}
              enableColumnFilters={false}
              enableColumnOrdering={false}
              enableHiding={false}
              positionToolbarAlertBanner="bottom"
              muiTableBodyCellProps={{ sx: { backgroundColor: '#FFFFFF' } }}
              muiTablePaginationProps={{ sx: { backgroundColor: '#FFFFFF' } }}
              muiBottomToolbarProps={{ sx: { backgroundColor: '#FFFFFF' } }}
              muiTopToolbarProps={{ sx: { backgroundColor: '#FFFFFF' } }}
              muiTableHeadRowProps={{ sx: { backgroundColor: '#FFFFFF' } }}
              muiTablePaperProps={{ sx: { boxShadow: 'none' } }}
            />
          </CardQuick>
        </Grid>
      </Grid>
      </React.Fragment>


  )
}

export default EsquebrasUsagePage;